import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { createRoot } from 'react-dom/client';
import App from './app/app';
const rootElement = document.getElementById('root');
if (!rootElement) {
    throw new Error('rootElement is null');
}
const root = createRoot(rootElement);
root.render(_jsx(_Fragment, { children: _jsx(App, {}) }));
